<!--
 * @Description: 常规工作/日常事务 班级成绩查询 列表
 * @Author: PF
 * @Date: 2023-01-05 15:11:27
 * @LastEditors: PF
 * @LastEditTime: 2023-08-08 14:22:08
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">班级成绩查询</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container class="hp100">
          <el-aside width="200px">
            <el-tree :data="bjsall" default-expand-all highlight-current :props="{ children: 'children', label: 'mc' }" @node-click="handleNodeClick" />
          </el-aside>
          <el-container>
            <el-header>
              <!-- 按钮区域 -->
              <div class="top_but">
                <ul class="checkbox_group">
                  <li>
                    <span>成绩类型：</span>
                    <el-checkbox-group v-model="xzcjlx" @change="chengJiChange">
                      <el-checkbox v-for="(item, index) in cjlxList" :key="index" :label="item.id">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                  </li>
                  <li>
                    <span>显示科目：</span>
                    <el-checkbox-group v-model="xzkm" @change="keMuChange">
                      <el-checkbox v-for="(item, index) in kmList" :key="index" :label="item.id">{{ item.kmmc }}</el-checkbox>
                    </el-checkbox-group>
                  </li>
                </ul>
              </div>
            </el-header>
            <el-main>
              <el-table :data="tableData" style="width: 100%" border v-loading="loading" height="100%">
                <el-table-column prop="xsxh" label="学号" align="center" min-width="150" show-overflow-tooltip />
                <el-table-column prop="xsxm" label="学生姓名" align="center" min-width="150" show-overflow-tooltip />
                <el-table-column prop="xb" label="性别" align="center" show-overflow-tooltip />
                <el-table-column v-for="(item, index) in tableHeader" :key="index" :prop="item.prop" :label="item.kmmc" align="center">
                  <el-table-column :prop="child.prop" :label="child.label" v-for="(child, childIndex) in item.children" :key="childIndex" align="center" min-width="100">
                    <template #default="scope">
                      <div v-for="(val, i) in scope.row.zpcjs" :key="i">
                        <div v-for="(xzcj, j) in xzcjList" :key="j">
                          <div v-if="xzcj.id === '1' && child.prop === 'ps' && item.kmmc === val.kmmc">
                            <p>{{val.psfs}}</p>
                          </div>
                          <div v-if="xzcj.id === '2' && child.prop === 'qz' && item.kmmc === val.kmmc">
                            <p>{{val.qzfs}}</p>
                            <!-- 0-正常考试，1-免考，2-免修，3-缺考 -->
                            <!-- <p v-if="val.qzckzt === 0">正常考试</p> -->
                            <p v-if="val.qzckzt === 1">免考</p>
                            <p v-if="val.qzckzt === 2">免修</p>
                            <p v-if="val.qzckzt === 3">缺考</p>
                          </div>
                          <div v-if="xzcj.id === '3' && child.prop === 'qm' && item.kmmc === val.kmmc">
                            <p>{{val.qmfs}}</p>
                            <!-- 0-正常考试，1-免考，2-免修，3-缺考 -->
                            <!-- <p v-if="val.qmckzt === 0">正常考试</p> -->
                            <p v-if="val.qmckzt === 1">免考</p>
                            <p v-if="val.qmckzt === 2">免修</p>
                            <p v-if="val.qmckzt === 3">缺考</p>
                          </div>
                          <div v-if="xzcj.id === '4' && child.prop === 'zp' && item.kmmc === val.kmmc">{{val.fs}}</div>
                          <div v-if="xzcj.id === '5' && child.prop === 'dj' && item.kmmc === val.kmmc">{{val.djmc}}</div>
                          <div v-if="xzcj.id === '6' && child.prop === 'jd' && item.kmmc === val.kmmc">{{val.jd}}</div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column v-if="isZcj" prop="zcj" label="总成绩" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zcj }}
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
            <el-footer class="pl0 pr0">
              <pagination :pagination="paginationObj" @ReturnData="initList()" />
            </el-footer>
          </el-container>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue'
import { homeCloseWindow, actionPost } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
import pagination from '@/components/pagination.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 复选区域 开始
const xzcjlx = ref([]) // 选中成绩类型
const xzcjList = ref([]) // 选中成绩列表
const xzkm = ref([]) // 选中科目
const xzkmList = ref([]) // 选中科目列表
const isZcj = ref(false) // 是否显示总成绩
const cjlxList = ref([
  { id: '1', prop: 'ps', label: '平时成绩' },
  { id: '2', prop: 'qz', label: '期中成绩' },
  { id: '3', prop: 'qm', label: '期末成绩' },
  { id: '4', prop: 'zp', label: '总评成绩' },
  { id: '5', prop: 'dj', label: '成绩等级' },
  { id: '6', prop: 'jd', label: '绩点' }
])
const kmList = ref([])
// 复选区域 结束
// 内容区域 开始
const loading = ref(false) // 加载
const tableData = ref() // 内容列表
const tableHeader = ref([])
const bjsall = ref() // 班级树
const bjid = ref([]) // 左侧班级id
const xqid = ref() // 学期id
// 分页
const paginationObj = ref() // 分页
const total = ref(0) // 总条数

// 方法区域 开始
// 点击树形控件
const handleNodeClick = (data) => {
  bjid.value = data.id
  initList()
}
// 选择 成绩类型
const chengJiChange = () => {
  xzcjList.value = []
  cjlxList.value.forEach((element) => {
    xzcjlx.value.forEach((e) => {
      if (element.id === e) {
        xzcjList.value.push(element)
      }
    })
  })
  initKeMuList()
}
// 选择 显示科目
const keMuChange = () => {
  xzkmList.value = []
  kmList.value.forEach((element) => {
    xzkm.value.forEach((e) => {
      if (element.id === e) {
        isZcj.value = e === '1'
        xzkmList.value.push(element)
      }
    })
  })
  initKeMuList()
}
// 列表
const initList = async (pageNo, pageSize) => {
  loading.value = true
  const info = {
    xqid: xqid.value,
    bjid: bjid.value,
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    order: 'xm',
    sort: 'asc'
  }
  const o = { url: '/api/v2/jiaowu/chengjizongpingchengji/banjilist', data: info }
  actionPost(o).then((res) => {
    loading.value = false
    if (res.code === 200) {
      
      xzcjlx.value = ['1', '2', '3', '4', '5', '6']
      kechengliebiao()
      chengJiChange()
      keMuChange()
      paginationObj.value = {
        pageNo: info.pageNo,
        pageSize: info.pageSize,
        total: res.data.total
      }
      tableData.value = res.data.list
      total.value = res.data.total
    } else {
      warningPrompt(res.message)
    }
  })
}
// 班级列表
const initBanJiList = () => {
  const o = { url: '/api/v2/pdp/banji/tree', data: { xqid: xqid.value } }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      bjsall.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 显示科目列表
const initKeMuList = () => {
  
  tableHeader.value = []
  xzkmList.value.forEach((element) => {
    if (element.kmmc !== '总成绩') {
      const obj = {
        kmmc: element.kmmc,
        children: xzcjList.value
      }
      tableHeader.value.push(obj)
    }
  })
}
// 学期列表
const initXueQiList = () => {
  const o = { url: '/api/v2/pdp/xueqi/list', data: { order: 'sx', sort: 'asc' } }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      if (res.data.length) {
        res.data.forEach((item) => {
          if (item.sfdqxq === true) {
            xqid.value = item.id
            initBanJiList()
          }
        })
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
// 课程列表
const kechengliebiao = () => {
  const o = { url: '/api/v2/jiaowu/chengjizongpingchengji/banjikemu', data: { bjid: bjid.value, xqid: xqid.value } }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      kmList.value = res.data
      kmList.value.push({ id: '1', kmmc: '总成绩' })
      xzkm.value = []
      xzkmList.value = []
      kmList.value.forEach((element) => {
        xzkm.value.push(element.id)
        xzkmList.value.push(element)
        if (element.kmmc !== '总成绩') {
          const obj = {
            kmmc: element.kmmc,
            children: xzcjList.value
          }
          tableHeader.value.push(obj)
          isZcj.value = true
        }
      })
    } else {
      warningPrompt(res.message)
    }
  })
}
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'banjichengjichaxun') {
      openList.value = true
      initXueQiList()
      initBanJiList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
